(function () {
  class MaxPlay {
    constructor() {
      this._maxPlayIDList = [0, 5, 6, 7, 8, 9, 10, 11, 17];

      this._baseGameSymbols = [];
      this._maxPlaySymbols = [];
      this._active = false;

      this._maxPlayStartSymbols = [
        [18, 18, 18, 18],
        [17, 18, 18, 18],
        [18, 18, 0, 18],
        [18, 17, 18, 18],
        [18, 18, 18, 18],
      ];

      messageBus.subscribe("spinner:GameConfigEvent", this.onGameConfigEvent.bind(this));
      messageBus.subscribe("freeSpinsTransitionIn", this.onFreespinsStart.bind(this));
      messageBus.subscribe("freeSpinsTransitionOut", this.onFreespinsEndEvent.bind(this));
      messageBus.subscribe("maxPlay", this.toggleMaxPlay.bind(this));
      messageBus.subscribe("maxPlay:RecoverGame", this.recoverGame.bind(this));
      messageBus.subscribe("maxPlay:DefaultReels", this.setDefaultReels.bind(this));
    }

    onGameConfigEvent() {
      this._introPopup = resourceManager.get("maxPlayIntroContainer:maxPlayIntroPopup");

      this._baseFadeAssets = resourceManager.get("preReels:reelBackersBase");

      this._maxPlayFadeAssets = [
        resourceManager.getContainer("maxPlayBackgroundContainer"),
        resourceManager.get("preReels:reelBackersMaxPlay"),
      ];

      for (let i = 0; i < this._maxPlayFadeAssets.length; i++) {
        this._maxPlayFadeAssets[i].visible = false;
      }
    }

    onFreespinsStart() {
      if (gameController.maxPlayActive) {
        this._maxPlayFadeAssets.forEach((asset) => {
          gsap.killTweensOf(asset);

          asset.alpha = 1;

          gsap.to(asset, {
            duration: 0.5,
            alpha: 0,
            onComplete: () => {
              asset.visible = false;
            },
          });
        });
      }
    }

    swapFreeSpinSymbols() {
      this._baseGameSymbols = [];
      this._maxPlaySymbols = [];

      for (var i = 0; i < 5; i++) {
        const reel = resourceManager.get("slotContainer:reelContainer:reel" + i);

        const rowList = [];
        const baseRowList = [];

        for (let j = 0; j < 4; ++j) {
          let sym = reel.getReelSymbol(j);

          baseRowList.push(sym);

          if ((sym <= 16 && sym >= 12) || (sym <= 4 && sym >= 1)) {
            sym = 18;
          }

          reel.setReelSymbol(j, sym);
          rowList.push(sym);
        }
        this._baseGameSymbols.push(baseRowList);
        this._maxPlaySymbols.push(rowList);
      }
    }

    onFreespinsEndEvent() {
      if (gameController.maxPlayActive) {
        this.swapFreeSpinSymbols();

        gameController.inMaxPlay = true;

        musicManager.maxPlayEnter();

        this._maxPlayFadeAssets.forEach((asset) => {
          gsap.killTweensOf(asset);

          asset.visible = true;
          asset.alpha = 0;

          gsap.to(asset, {
            duration: 0.5,
            alpha: 1,
          });
        });
      }
    }

    recoverGame() {
      this.toggleMaxPlay({ active: true }, true);
    }

    setDefaultReels() {
      for (var i = 0; i < 5; i++) {
        const reel = resourceManager.get("slotContainer:reelContainer:reel" + i);

        for (let j = 0; j < 4; ++j) {
          reel.setReelSymbol(j, this._maxPlayStartSymbols[i][j]);
        }
      }
    }

    toggleReels(active, showPopup = true) {
      gameController.stopCyclingWins();
      gameController.returnCashOverlay();
      gameController.symbolLandAnimator.skip();

      if (active) {
        musicManager.maxPlayEnter();

        if (showPopup) {
          this._introPopup.showPopup();
          gameData.winningsMeter.set(0);
        }

        this._baseGameSymbols = [];

        for (var i = 0; i < 5; i++) {
          const reel = resourceManager.get("slotContainer:reelContainer:reel" + i);

          const rowList = [];

          for (let j = 0; j < 4; ++j) {
            const sym = reel.getReelSymbol(j);
            rowList.push(sym);

            if (this._maxPlaySymbols.length === 0) {
              reel.setReelSymbol(j, this._maxPlayStartSymbols[i][j]);
            } else {
              reel.setReelSymbol(j, this._maxPlaySymbols[i][j]);
            }
          }
          this._baseGameSymbols.push(rowList);
        }
      } else {
        musicManager.maxPlayExit();

        this._maxPlaySymbols = [];

        if (showPopup) {
          gameData.winningsMeter.set(0);
        }

        for (var i = 0; i < 5; i++) {
          const reel = resourceManager.get("slotContainer:reelContainer:reel" + i);

          const rowList = [];

          for (let j = 0; j < 4; ++j) {
            const sym = reel.getReelSymbol(j);
            rowList.push(sym);

            reel.setReelSymbol(j, this._baseGameSymbols[i][j]);
          }
          this._maxPlaySymbols.push(rowList);
        }
      }
      gameController.returnCashOverlay();
    }

    toggleMaxPlay(task, instant = false) {
      this._active = task.active;
      this.toggleReels(this._active, !instant);

      const duration = instant ? 0 : 0.5;

      if (this._active) {
        gsap.killTweensOf(this._baseFadeAssets);

        gameController.inMaxPlay = true;

        this._baseFadeAssets.alpha = 1;

        gsap.to(this._baseFadeAssets, {
          duration,
          alpha: 0,
          onComplete: () => {
            this._baseFadeAssets.visible = false;
          },
        });

        this._maxPlayFadeAssets.forEach((asset) => {
          gsap.killTweensOf(asset);

          asset.visible = true;
          asset.alpha = 0;

          gsap.to(asset, {
            duration,
            alpha: 1,
          });
        });
      } else {
        gsap.killTweensOf(this._baseFadeAssets);

        gameController.inMaxPlay = false;

        this._baseFadeAssets.visible = true;
        this._baseFadeAssets.alpha = 0;

        gsap.to(this._baseFadeAssets, {
          duration,
          alpha: 1,
        });

        this._maxPlayFadeAssets.forEach((asset) => {
          gsap.killTweensOf(asset);

          asset.alpha = 1;

          gsap.to(asset, {
            duration,
            alpha: 0,
            onComplete: () => {
              asset.visible = false;
            },
          });
        });
      }
    }
  }

  new MaxPlay();
})();
